var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e;
import { fromPairs } from "../collections";
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
import { CustomParameterInstanceFactory, ModifierInstanceAvailabilityService, ModifierInstanceFactory, ParameterScopeProvider, ProductInstanceFactory, } from "../ordering";
let VariantInstanceFactory = class VariantInstanceFactory {
    constructor(customParameterInstanceFactory, productInstanceFactory, modifierInstanceFactory, modifierInstanceAvailabilityService, parameterScopeProvider) {
        this.customParameterInstanceFactory = customParameterInstanceFactory;
        this.productInstanceFactory = productInstanceFactory;
        this.modifierInstanceFactory = modifierInstanceFactory;
        this.modifierInstanceAvailabilityService = modifierInstanceAvailabilityService;
        this.parameterScopeProvider = parameterScopeProvider;
        makeImmutable(this);
    }
    create(variant) {
        const customParameterInstances = this.customParameterInstanceFactory.fromCustomParameterSet(variant.customParameterChoices);
        const parameterScope = this.parameterScopeProvider.fromVariant(variant, null);
        const modifierInstances = variant.productTypes.type === "Single"
            ? this.irremovableModifierInstances(variant.productTypes.productType, parameterScope)
            : {};
        return this.productInstanceFactory.fromStorageData({
            commonConfig: {
                customParameterInstances: fromPairs(customParameterInstances.objects.mapOptional((instance) => instance.storageData === null
                    ? null
                    : [instance.typeId.value, instance.storageData])),
                modifierInstances,
            },
            parts: this.instanceParts(variant.productTypes),
        });
    }
    irremovableModifierInstances(productType, parameterScope) {
        // NOTICE Include default irremovable nondivisible modifiers in menu prices
        return fromPairs(productType.nonDivisibleModifierTypes.objects.mapOptional((modifierType) => {
            if (modifierType.exchangePolicy === "NotIncluded" &&
                modifierType.isFiscalizedSeparately) {
                const modifierSettings = productType.modifierSettings(modifierType);
                const itemQuantities = modifierSettings.defaultItems.filterWithKey((modifierItemType) => modifierType.itemType(modifierItemType).irremovable);
                if (itemQuantities.values.every((value) => value.isZero)) {
                    return null;
                }
                const instance = this.modifierInstanceFactory.create({
                    modifierType,
                    modifierSettings,
                    items: itemQuantities.entries.map(([id, qty]) => [id, qty, null]),
                });
                if (this.modifierInstanceAvailabilityService.availability(instance, parameterScope).isAvailable.isPossible) {
                    return [modifierType.id.value, instance.storageData];
                }
                return null;
            }
            return null;
        }));
    }
    instanceParts(productTypes) {
        switch (productTypes.type) {
            case "Single":
                return {
                    type: "SinglePart",
                    part: {
                        productTypeId: productTypes.productType.id.value,
                        productConfig: {
                            customParameterInstances: {},
                            modifierInstances: {},
                        },
                    },
                };
            case "Halves":
                return {
                    type: "Halves",
                    first: {
                        productTypeId: productTypes.first.id.value,
                        productConfig: {
                            customParameterInstances: {},
                            modifierInstances: {},
                        },
                    },
                    second: {
                        productTypeId: productTypes.second.id.value,
                        productConfig: {
                            customParameterInstances: {},
                            modifierInstances: {},
                        },
                    },
                };
        }
    }
};
VariantInstanceFactory = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof CustomParameterInstanceFactory !== "undefined" && CustomParameterInstanceFactory) === "function" ? _a : Object, typeof (_b = typeof ProductInstanceFactory !== "undefined" && ProductInstanceFactory) === "function" ? _b : Object, typeof (_c = typeof ModifierInstanceFactory !== "undefined" && ModifierInstanceFactory) === "function" ? _c : Object, typeof (_d = typeof ModifierInstanceAvailabilityService !== "undefined" && ModifierInstanceAvailabilityService) === "function" ? _d : Object, typeof (_e = typeof ParameterScopeProvider !== "undefined" && ParameterScopeProvider) === "function" ? _e : Object])
], VariantInstanceFactory);
export { VariantInstanceFactory };
